module.exports = __webpack_public_path__ + "img/8.8bc74652.png";